import { UserStatus } from "@/utils/api-client";

export default {
  [UserStatus.INDIVIDUAL]: "Физическое лицо",
  [UserStatus.ENTREPRENEUR]: "ИП",
  [UserStatus.LEGAL_ENTITY]: "Юридическое лицо"
};
